
import PWPParticipate from '~/pages/_lang/pwp-participate/_id'
export default PWPParticipate
